import PropTypes from 'prop-types';
import './Container.css';

const Container = ({ children }) => {
  return <main className="main-container">{children}</main>;
};

export default Container;

Container.propTypes = {
  children: PropTypes.node.isRequired,
};
